import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ContactType} from 'src/app/models';

@Component({
    selector: 'app-contact-type-edit',
    templateUrl: './contact-type-popup.component.html',
    styleUrls: ['./contact-type-popup.component.scss']
})
export class ContactTypePopupComponent {
    contactType: ContactType;
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.contactType = new ContactType(this.data.contact_type_id, this.data.contact_type, this.data.description, this.data.admin_only);
    }
}
